<template>
    <div class="container pt-5 pb-5 page">
        <h1 class="mb-5">Ons Referral Programma</h1>
        <program></program>
        <p><b>Meer informatie en je unieke doorverwijs link kunt u vinden in uw profiel na registratie.</b></p>
        <hr class="mb-5" />
        <register-btns></register-btns>
    </div>
</template>

<script>
import Program from '@/components/Referral/Program';
import RegisterButtons from '@/components/RegisterButtons';
export default {
    components: {
        'register-btns': RegisterButtons,
        'program': Program
    },
}
</script>
